import { CustomFile } from './types';

// ----------------------------------------------------------------------

export function fileData(file: CustomFile | string) {
  if (typeof file === 'string') {
    return {
      key: file,
      name: file,
      path: file,
      size: 0
    };
  }

  return {
    key: file.preview || file.name,
    name: file.name,
    size: file.size,
    path: file.path || file.name,
    type: file.type,
    preview: file.preview,
    lastModified: file.lastModified
  };
}

export function getFileThumb(file: CustomFile | string) {
  if (typeof file === 'string') {
    return file;
  }
  return file.preview || '';
}

export function getFileFormat(fileName: string) {
  const extension = fileName.split('.').pop()?.toLowerCase() || '';

  const imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
  const documentFormats = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
  const spreadsheetFormats = ['xls', 'xlsx', 'csv'];
  const presentationFormats = ['ppt', 'pptx'];
  const archiveFormats = ['zip', 'rar', '7z', 'tar', 'gz'];

  if (imageFormats.includes(extension)) return 'image';
  if (documentFormats.includes(extension)) return 'document';
  if (spreadsheetFormats.includes(extension)) return 'spreadsheet';
  if (presentationFormats.includes(extension)) return 'presentation';
  if (archiveFormats.includes(extension)) return 'archive';

  return 'file';
}
